import { render, staticRenderFns } from "./BaseChartWrapper.vue?vue&type=template&id=1fa6d338&"
import script from "./BaseChartWrapper.vue?vue&type=script&lang=ts&"
export * from "./BaseChartWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports